import { useState, useEffect, useRef } from "react";
import { CircularProgress, Box, IconButton, Button } from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { CustomGrid } from "../../../components/tableComponent";
import LeaguesStatus from "./leaguesStatus";
import { getLeagueSeasons } from "../../../services/leagues";
import EditIcon from "@mui/icons-material/Edit";
import EditSeason from "./editSeason";
import moment from "moment";

const SeasonTable = ({ refetch, setRefetch }) => {
  const navigate = useNavigate();
  // State management
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortModel, setSortModel] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [isEditSeasonOpen, setIsEditSeasonOpen] = useState(false);

  const { id: league_id } = useParams();

  const handleSeasonEdit = (event, row) => {
    console.log("row === ", row)
    event.stopPropagation();
    setSelectedSeason(row);
    setIsEditSeasonOpen(true);
  };

  // Column definitions
  const columns = [
    {
      field: "start_date",
      headerName: "Start Date",
      minWidth: 120,
      sortable: true,
      flex: 1,
      renderCell: (params) => {
        return moment(params.row.start_date).format("MM/DD/YYYY")
      }
    },
    {
      field: "end_date",
      headerName: "End Date",
      minWidth: 120,
      sortable: true,
      flex: 1, 
      renderCell: (params) => {
        return moment(params.row.end_date).format("MM/DD/YYYY")
      }
    },
    {
      field: "season_name",
      headerName: "Name",
      minWidth: 200,
      sortable: true,
      flex: 2,
    },
    {
      field: "weeks_for_season_games",
      headerName: "# of Weeks",
      minWidth: 110,
      sortable: true,
      flex: 1.5,
    },
    {
      field: "starting_theme",
      headerName: "Theme",
      minWidth: 150,
      sortable: true,
      flex: 1.5,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      sortable: true,
      flex: 1.5,
      renderCell: (params) => <LeaguesStatus data={params.row} />,
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 100,
      sortable: true,
      flex: 1.5,
      renderCell: (params) => (
        params.row.status !== "Completed" && <IconButton
          aria-label="edit"
          color="primary"
          onClick={(event) => handleSeasonEdit(event, params.row)}
        >
          <EditIcon />
        </IconButton>
      ),
    },
  ];

  // Data fetching function
  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getLeagueSeasons(league_id);
      setData(
        response.data.results.map((ele, idx) => ({
          id: idx,
          ...ele,
          actions: ele.season_id,
        }))
      );
      setTotalRecords(response.data.results.length);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [refetch]);

  // Event handlers
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  const handleSortChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  const handleRowSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const handleRowClick = (params) => {
    const leagueId = window.location.pathname.split("/")[2];
    navigate(`/my_leagues/${leagueId}/season/${params.row.season_id}`, {
      state: {
        seasonData: params.row,
      },
    });
  };

  const handleRefresh = () => {
    fetchData();
  };

  const handleCloseEdit = () => {
    setSelectedSeason(null);
    setIsEditSeasonOpen(false);
  };

  // Loading state
  if (loading && !data.length) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  console.log("data === ____ +++", data);

  return (
    <Box sx={{ width: "100%" }} className="mt-2">
      {data?.length > 0 &&
        <>
          <div className="d-flex justify_content_end">
            <div className="league-header-content">
              <p className="heading-title-players">Seasons</p>
            </div>
          </div>
          <CustomGrid
            columns={columns}
            data={data}
            loading={loading}
            perPageCount={pageSize}
            currentPage={page}
            totalPages={totalRecords}
            isServerPagination={false}
            onChangeRecords={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            onSortModelChange={handleSortChange}
            onRowClick={handleRowClick}
            onRowSelectionModelChange={handleRowSelectionChange}
            rowHeight={56}
            selectionModel={selectedRows}
            searchBar={null}
            disableSorting={true}
            className="table-row-cursor-selectable"
          />
        </>
      }

      {isEditSeasonOpen && selectedSeason && (
        <EditSeason
          seasonData={selectedSeason}
          open={isEditSeasonOpen}
          onClose={handleCloseEdit}
          setRefetch={setRefetch}
        />
      )}
    </Box>
  );
};

export default SeasonTable;
